/**
 * TA7 Leasehold Information Form — 5th Edition (2025).
 *
 * Thin wrapper around the schema-driven FormWizard. The canonical schema
 * (sections, question keys, conditional visibility) is served by
 * /api/ta7/schema, so the wizard, the stored answers, and the official-format
 * PDF renderer all share one source of truth — the keys a client fills are
 * exactly the keys the TA7 PDF renderer reads back.
 */
import FormWizard from "./TAFormWizard";

export default function TA7IntakeForm() {
  return <FormWizard formType="ta7" />;
}
